<script>
  import options from './FeaturedGroups.options'
  export default options
</script>

<template>
  <section class="kb-featured-groups">

    <div class="kb-featured-groups__content-wrapper">

      <div class="kb-featured-groups__content-wrapper-left">

        <article class="kb-spot-card kb-featured-post-spot-card kb-featured-groups__spot-card" :class="colorTheme"> 
  
          <div class="kb-spot-card-grid__box__decoration">
            <svg width="512" height="445" viewBox="0 0 512 445" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation"> <path d="M-698.154 720.628C-614.642 775.767 -501.149 766.579 -427.628 693.059L103.706 162.567C312.897 -46.6237 652.06 -46.6237 861.245 162.567C1070.44 371.759 1070.44 710.921 861.245 920.107C652.054 1129.3 312.892 1129.3 103.706 920.107" stroke="white" stroke-width="130.892" stroke-miterlimit="10" /> <path d="M-958.539 919.683C-1167.73 710.492 -1167.73 371.329 -958.539 162.143C-749.348 -47.0478 -410.185 -47.0478 -200.999 162.143L330.335 693.478C414.361 777.504 550.59 777.504 634.615 693.478C718.641 609.452 718.641 473.223 634.615 389.197C550.59 305.171 414.361 305.171 330.335 389.197L-200.999 919.688C-250.11 968.799 -306.376 1006.38 -366.45 1032.43" stroke="white" stroke-width="130.892" stroke-miterlimit="10" /> </svg>
          </div>

          <div class="kb-spot-card__box__content">

            <template v-if="groupsList.length > 0">
              <h2 class="kb-spot-card__box__title">{{  getLabel("title") }}</h2>
            </template>
            <template v-else>
              <h2 class="kb-spot-card__box__title">{{  getLabel("noGroupsTitle") }}</h2>
            </template>

            <template v-if="groupsList.length > 0">

              <ul class="kb-featured-groups__spot-card-list">
                
                <template v-for="group, index in groupsList" :key="index">  
                  
                  
                  <li class="kb-featured-groups__spot-card-list-item">
                    
                      <a :href="group.href"> 
                        {{  group.groupTitle }} 
                      
                        <div class="kb-featured-groups__spot-card-list-item-arrow-svg">
                          <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 10"><g stroke="#E8001D"><path d="m12.167 1 3.623 4-3.623 4" stroke-linejoin="round"/><path d="M11.746 5H0"/></g></svg>
                        </div>
                      </a>


                  </li>

                </template>

              </ul>

            </template>

              <template v-if="groupsList.length > 0">
                <a
                  :href="hasGroupsButton.href"
                  :target="hasGroupsButton.target"
                  class="kb-button kb-button--border-color"
                >
                  {{  getLabel("hasGroupsButtonText") }}
                
                </a>
              </template>
              <template v-else>
                <a
                  :href="noGroupsButton.href"
                  :target="noGroupsButton.target"
                  class="kb-button kb-button--border-color"
                >
                  {{  getLabel("noGroupsButtonText") }}
                
                </a>
              </template>

          </div>

        </article>
      </div>

      <div class="kb-featured-groups__content-wrapper-right">
        
        <ContentCarousel
          :contentJson="sliderContentJson"
          type="groups"
          :carouselId="sliderId"
        />

      </div>

    </div>




  </section>
</template>
